import { useDashboard } from '@cobliteam/dashboard/src/providers/DashboardProvider';
import { useLanguage } from '@cobliteam/i18n';
import Typography from '@cobliteam/ui/components/Typography';
import { getTextForLanguage } from '@cobliteam/ui-business/utils';
import { useEffect } from 'react';
import PageHeaderTitle from '../PageHeader/components/PageHeaderTitle';
import PageInfo from '../PageInfo';

const PageTitle = ({ title }: { title?: string }) => {
  const { sidebar } = useDashboard();
  const { currentLanguage } = useLanguage();
  const page = sidebar?.route?.page;
  const pageTitle = getTextForLanguage(sidebar?.route?.page?.title, currentLanguage) || 'Sem título';
  const finalTitle = title || pageTitle;

  useEffect(() => {
    if (finalTitle && finalTitle !== 'Sem título') {
      document.title = `Cobli - ${finalTitle}`;
    }
  }, [finalTitle]);

  return (
    <PageHeaderTitle>
      <div className='flex items-center'>
        <Typography variant='heading-4xl' className='mr-2 first-letter:uppercase' as='h1' data-testid='page-title'>
          {finalTitle}
        </Typography>
        <PageInfo />
      </div>
      {page?.description && (
        <div className='mt-1 flex items-center' data-testid='page-description'>
          <Typography variant='text-lg' className='mr-2' color='secondary'>
            {getTextForLanguage(page?.description, currentLanguage)}
          </Typography>
        </div>
      )}
    </PageHeaderTitle>
  );
};

export default PageTitle;
